import styled from "styled-components";

import { SCROLLBAR_CONTAINER } from "./constants";

export const ChatAssetTreeWrapper = styled.div`
    height: 100%;
    
    ${SCROLLBAR_CONTAINER} {
        overflow: unset !important;
    }
`;